import { Input } from '@/components/common/Input'
import { CheckboxGroup } from '@/components/common/CheckboxGroup'
import { RadioGroup } from '@/components/common/RadioGroup'
import { StepShell } from '../StepShell'
import { HABIT_OPTIONS, DIET_OPTIONS, MOUTHWASH_FLOSS_OPTIONS } from '@/lib/constants'

const DEFAULT = {
  habits: [],
  diet: null,
  brushing_frequency: '',
  mouthwash_floss: [],
}

export function PersonalHistoryStep({ value, onChange }) {
  const v = { ...DEFAULT, ...(value || {}) }
  const set = (patch) => onChange?.({ ...v, ...patch })

  return (
    <StepShell
      eyebrow="Section 4 — Phase 2"
      title="Personal history"
      description="Lifestyle habits and oral hygiene routine."
    >
      <CheckboxGroup
        label="Habits"
        options={HABIT_OPTIONS}
        value={v.habits}
        onChange={(arr) => set({ habits: arr })}
        columns={3}
      />
      <RadioGroup
        label="Diet"
        options={DIET_OPTIONS}
        value={v.diet}
        onChange={(val) => set({ diet: val })}
        columns={3}
        allowClear
      />
      <div className="grid gap-4 sm:grid-cols-2">
        <Input
          label="Brushing frequency"
          value={v.brushing_frequency}
          onChange={(e) => set({ brushing_frequency: e.target.value })}
          placeholder="e.g. Twice daily"
        />
        <CheckboxGroup
          label="Additional oral hygiene"
          options={MOUTHWASH_FLOSS_OPTIONS}
          value={v.mouthwash_floss}
          onChange={(arr) => set({ mouthwash_floss: arr })}
          columns={2}
        />
      </div>
    </StepShell>
  )
}
